import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { getStateFeatureFlags } from '@/store/getters'
import { defineAsyncComponent, computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Notifications',
  setup(__props) {

const NotificationsCenter = defineAsyncComponent(
  () => import('./NotificationCenter.vue')
)

const NotificationsInbox = defineAsyncComponent(
  () => import('./NotificationsInbox.vue')
)

const canAccessNewNotificationInbox = computed(() => {
  return getStateFeatureFlags()['ENABLE_NEW-NOTIFICATION-INBOX']
})

return (_ctx: any,_cache: any) => {
  return (canAccessNewNotificationInbox.value)
    ? (_openBlock(), _createBlock(_unref(NotificationsInbox), { key: 0 }))
    : (_openBlock(), _createBlock(_unref(NotificationsCenter), { key: 1 }))
}
}

})